import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";

import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import useFormReset from "../../../../../../hooks/useFormReset";
import useStepSpecific from "../../../../../../hooks/useStepSpecific";
import React from "react";
import { createFormalValidationFromSchema } from "../../../../../../yup/utils/yupUtils";
import { createAdditionalDocDetailsValidationSchemas } from "../../../../../../yup/additionalDoc/AdditionalDocDetailsValidationSchemas";
import {
  completeAdditionalDocDetailStep,
  setStepAdditionalDocDetailEdited,
} from "../../../../../../store/redux/slice/Forms/regprofAdditionalDocForm";
import AdditionalDocStepDetails from "./AdditionalDocStepDetails";
import { initialRegprofAdditionalDocApplication } from "../../../../../../init/regprofAdditionalDocInitialValues";

const RegprofAdditionalDocStepDetails = () => {
  const regprofAdditionalDocForm = useAppSelector((state) => {
    return state.Forms.RegprofAdditionalDocForm;
  });

  const fullSchema = createAdditionalDocDetailsValidationSchemas;
  const formalSchema = createFormalValidationFromSchema(fullSchema);

  const { onSubmit, methods } = useStepSpecific(
    regprofAdditionalDocForm.additionalDocDetail,
    regprofAdditionalDocForm.id,
    baseEndpointPaths.regprofAdditionalDoc,
    formalSchema,
    setStepAdditionalDocDetailEdited,
    completeAdditionalDocDetailStep,
    initialRegprofAdditionalDocApplication,
  );

  useFormReset("REGPROF_ADDITIONAL_DOCUMENTS", regprofAdditionalDocForm.additionalDocDetail, methods.reset);

  return (
    <AdditionalDocStepDetails
      fullSchema={fullSchema}
      formalSchema={formalSchema}
      methods={methods}
      onSubmit={onSubmit}
    />
  );
};
export default RegprofAdditionalDocStepDetails;
